export const deClientPortalNotificationSettingsContentPages = {
    settings: {
        notificationSettingsContent: {
            notifications: {
                eMailNotifications: 'E-Mail-Benachrichtigungen',
                subtitle: 'Wann erhalte ich Benachrichtigungen?',
                appraiserOnly: {
                    message: 'Benachrichtigungseinstellungen für Gutachter können aktuell nur in der Gutachtersoftware geändert werden.',
                    action: 'Zur Gutachtersoftware',
                },
                explanation: {
                    item1: {
                        start: 'Sie erhalten standardmäßig nur als ',
                        emphasis: 'Zuständige/r oder Beobachter/in',
                        end: ' Benachrichtigungen zu einem Auftrag. Als solche/r gehören Sie automatisch zu den Benachrichtigten aller (Aufgaben-)Unterhaltungen des Auftrags.',
                    },
                    item2: {
                        start: 'Auch ohne diese Voraussetzung werden Sie benachrichtigt, wenn Sie ',
                        taskEmphasis: 'zuständig für eine Aufgabe',
                        middle: ' sind oder zu den ',
                        threadEmphasis: 'Benachrichtigten einer Unterhaltung',
                        end: ' gehören.',
                    },
                    item3: {
                        start: 'Sie werden ',
                        emphasis: 'nicht über Ihre eigenen Änderungen und Nachrichten',
                        end: ' informiert.',
                    },
                },
                table: {
                    off: 'AUS',
                    immediate: 'SOFORTMAIL',
                    batch: 'TAGESBERICHT',
                    batchTooltip:
                        'Sollte es Neuigkeiten geben, erhalten Sie bis zu zwei Mal am Tag eine Zusammenfassung der Ereignisse per Mail.',
                },
            },
        },
    },
}
